import { createContext, useContext } from 'react';
import { MissingAccess } from 'api/element-issues';

export interface IssueCounts {
    unresolved: number;
    unanswered: number;
    // Empty when the user can resolve both gates (Publishing_Board.md §3.4)
    missingAccess: MissingAccess[];
    loaded: boolean;
}

export interface MoveBlockState {
    // Increments on every blocked Save & Move click so the banner re-runs its shake animation
    attempt: number;
    inconsistencies: boolean;
    clarifications: boolean;
    missingAccess: MissingAccess[];
}

export interface EditPanelBridge {
    reportIssueCounts: (counts: IssueCounts) => void;
    moveBlock: MoveBlockState | null;
    // Auto-expand of the issue cards on gating errors (§2.2): bumped by the blocked
    // Save & Move flow and by the Available-for-data-questions toggle (§4.1)
    inconsistenciesExpandToken: number;
    expandInconsistencies: () => void;
    clarificationsExpandToken: number;
    expandClarifications: () => void;
}

export const EditPanelBridgeContext = createContext<EditPanelBridge | null>(null);

export const useEditPanelBridge = () => useContext(EditPanelBridgeContext);
